// Entry point for Vite. Phase 2 is complete: the legacy monolith is
// gone, `./bootstrap` owns the typed wiring of every extracted module.
//
// Self-contained install()s (theme, font scale, intro modal, header
// menu) run here because they have no factory-level deps on the rest
// of the app — they just hook DOM listeners on DOMContentLoaded-safe
// elements. The heavier controllers (session, sync, dropdowns, …) are
// created inside bootstrap.ts with the state object.

// Flip the boot marker the inline script in index.html watches for —
// if this flag isn't set 5s after navigation, the page auto-reloads to
// recover from Brave iOS bfcache restores pointing at stale
// /assets/main-<hash>.js URLs that 404 silently.
(window as unknown as { __KP_BOOTED__?: boolean }).__KP_BOOTED__ = true;

import "./styles/index.css";
import "./bootstrap";
import { installContactFooter } from "./ui/contact-footer";
import { installTheme } from "./ui/theme";
import { installFontScale } from "./ui/font-scale";
import { installIntroModal } from "./ui/intro";
import { installHeaderMenu } from "./ui/header-menu";

installTheme();
installFontScale();
installIntroModal();
installHeaderMenu();
installContactFooter();
